import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "../../lib/axios"; 
import "./Profile.css";

const Profile = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await axios.get("/auth/profile");
        setUser(res.data);
      } catch (err) {
        console.error("Failed to load profile:", err.response?.data || err.message);
      }
    };

    fetchProfile();
  }, []);

  if (!user) {
    return <p>Loading profile...</p>;
  }

  return (
    <div className="main-content">
      <h1>MY PROFILE</h1>
      <div className="profile-details">
        <p><strong>Name:</strong> {user.name}</p>
        <p><strong>Email:</strong> {user.email}</p>
        <p><strong>Phone:</strong> {user.telephone}</p>
        <p><strong>Role:</strong> {user.role}</p>
      </div>
      <div className="profile-actions">
       {/* <Link to="/editprofile" className="profile-button">EDIT</Link>*/}
      </div>
    </div>
  );
};

export default Profile;
